import Vue from 'vue'
import VueI18n from 'vue-i18n'

import {de_DE} from '@shared/language/de_DE.js'
import {en_EN} from '@shared/language/en_EN.js'

Vue.use(VueI18n)

const messages = {
  de: de_DE,
  en: en_EN
}

// Create VueI18n instance with options
export default new VueI18n({
  locale: 'de', // set locale
  fallbackLocale: 'de',
  messages // set locale messages
})
